if(!customElements.get('modal-link')) {
  class ComponentAnchorLink extends HTMLElement {
    constructor() {
      super();
      this.target = document.querySelector('.'+ this.dataset.target);
      this.openButton = this.querySelector('button.link');
      this.closeButton = this.target.querySelector('button.close');
      this.openButton.addEventListener('click', ()=>{
        this.target.style.display = 'flex';    
      });
      this.closeButton.addEventListener('click', (e)=>{
        e.preventDefault()
        e.stopImmediatePropagation()
        this.target.style.display = 'none';    
      });

    }


  }
  customElements.define('modal-link', ComponentAnchorLink);
}